module.exports = require("./ks-Arab");